module.exports = __webpack_public_path__ + "static/media/loginImage.acd747a5.png";